import React, { useState, useEffect } from 'react';
import axios from 'axios';
import NavbarAdminMex from '../components/navbar';
import './referente.css';

const Referente = () => {
  const [formData, setFormData] = useState({
    codigo_sucursal: '',
    porcentaje_comision: ''
  });
  const [message, setMessage] = useState('');
  const [panelData, setPanelData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [editingCommissions, setEditingCommissions] = useState(false);
  const [editedValues, setEditedValues] = useState(null);
  const [editMode, setEditMode] = useState({ type: null, level: null });
  const [editingBaseCommissions, setEditingBaseCommissions] = useState(false);
  const [baseCommissionValues, setBaseCommissionValues] = useState(null);
  const [referenteData, setReferenteData] = useState(null);
  const [editingReferente, setEditingReferente] = useState(null);

  const fetchPanelData = async () => {
    try {
      const usuario_id = localStorage.getItem('usuario_id');
      const token = localStorage.getItem('token');

      const response = await axios.get(`https://99envios.app/api/online/ver-panel/${usuario_id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setPanelData(response.data);
    } catch (error) {
      console.error('Error al obtener datos del panel:', error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const usuario_id = localStorage.getItem('usuario_id');
        const token = localStorage.getItem('token');
        // Fetch panel data
        const panelResponse = await axios.get(`https://99envios.app/api/online/ver-panel/${usuario_id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setPanelData(panelResponse.data);

        // Fetch referente data
        const referenteResponse = await axios.get(`https://api.99envios.app/api/online/referente/1`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setReferenteData(referenteResponse.data);
      } catch (error) {
        console.error('Error al obtener datos:', error);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await axios.post('https://api.99envios.app/api/online/referente', 
        {
          codigo_sucursal: parseInt(formData.codigo_sucursal),
          porcentaje_comision: parseFloat(formData.porcentaje_comision)
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      setMessage('Referente creado exitosamente');
      setFormData({ codigo_sucursal: '', porcentaje_comision: '' });
      setIsModalOpen(false);
    } catch (error) {
      setMessage('Error al crear referente: ' + error.message);
    }
  };

  const handleEdit = async (level, type, newValue) => {
    try {
      const token = localStorage.getItem('token');
      const updatedData = {
        comision_vendedor: editedValues?.comision_vendedor || panelData.comision_vendedor,
        comision_referido: editedValues?.comision_referido || panelData.comision_referido,
        cantidad_retorno_1: panelData.cantidad_retorno_1,
        porcentaje_retorno_1: panelData.porcentaje_retorno_1,
        cantidad_retorno_2: panelData.cantidad_retorno_2,
        porcentaje_retorno_2: panelData.porcentaje_retorno_2,
        cantidad_retorno_3: panelData.cantidad_retorno_3,
        porcentaje_retorno_3: panelData.porcentaje_retorno_3,
        cantidad_retorno_4: panelData.cantidad_retorno_4,
        porcentaje_retorno_4: panelData.porcentaje_retorno_4,
        cantidad_retorno_5: panelData.cantidad_retorno_5,
        porcentaje_retorno_5: panelData.porcentaje_retorno_5,
      };

      if (level) {
        updatedData[`${type}_retorno_${level}`] = type === 'cantidad' ? 
          parseInt(newValue) : parseFloat(newValue);
      }

      await axios.post(`https://99envios.app/api/online/actualizar-panel/${panelData.id}`, 
        updatedData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      setMessage('Panel actualizado exitosamente');
      fetchPanelData();
      setEditMode({ type: null, level: null });
    } catch (error) {
      setMessage('Error al actualizar panel: ' + error.message);
    }
  };

  const handleBaseCommissionsEdit = async () => {
    try {
      const token = localStorage.getItem('token');
      const updatedData = {
        ...panelData,
        comision_vendedor: parseFloat(baseCommissionValues.comision_vendedor),
        comision_referido: parseFloat(baseCommissionValues.comision_referido),
      };

      await axios.post(
        `https://99envios.app/api/online/actualizar-panel/${panelData.id}`,
        updatedData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setMessage('Comisiones base actualizadas exitosamente');
      fetchPanelData();
      setEditingBaseCommissions(false);
      setBaseCommissionValues(null);
    } catch (error) {
      setMessage('Error al actualizar comisiones: ' + error.message);
    }
  };

  const handleEditReferente = async (referenteData) => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        `https://api.99envios.app/api/online/referente/${referenteData.id}`,
        {
          id_users: referenteData.id_users,
          nombre: referenteData.nombre,
          id_padre: referenteData.id_padre,
          nivel: referenteData.nivel,
          porcentaje_comision: referenteData.porcentaje_comision
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setMessage('Referente actualizado exitosamente');
      const usuario_id = localStorage.getItem('usuario_id');
      const referenteResponse = await axios.get(
        `https://api.99envios.app/api/online/referente/${usuario_id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setReferenteData(referenteResponse.data);
      setEditingReferente(null);
    } catch (error) {
      setMessage('Error al actualizar referente: ' + error.message);
    }
  };

  return (
    <>
      <NavbarAdminMex title="Referentes" />
      <div className="dashboard-containerAD">
        <div className="panel-header">
          <h2>Panel de Comisiones</h2>
          <div className="header-actions">
            {message && (
              <div className={`message-container ${message.includes('Error') ? 'error' : 'success'}`}>
                <p>{message}</p>
              </div>
            )}
            <button className="add-button" onClick={() => setIsModalOpen(true)}>
              Agregar Referente
            </button>
          </div>
        </div>

        {panelData && (
          <div className="panel-table-container">
            {/* Comisiones Base section */}
            <div className="commission-summary">
              <div className="summary-group">
                <div className="summary-item">
                  <span className="summary-label">Comisión Referido</span>
                  <span className="summary-value">${panelData.comision_referido}</span>
                </div>
                <div className="summary-item">
                  <span className="summary-label">Comisión Vendedor</span>
                  <span className="summary-value">${panelData.comision_vendedor}</span>
                </div>
                <button 
                  className="edit-button primary"
                  onClick={() => {
                    setEditingBaseCommissions(true);
                    setBaseCommissionValues({
                      comision_referido: panelData.comision_referido,
                      comision_vendedor: panelData.comision_vendedor
                    });
                  }}
                >
                  Editar Comisiones Base
                </button>
              </div>
            </div>

            {/* Tabla de retornos */}
            <table className="panel-table">
              <thead>
                <tr>
                  <th>Cantidad de Envíos</th>
                  <th>Porcentaje de Retorno</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {[1, 2, 3, 4, 5].map((level) => (
                  <tr key={level}>
                    <td>≥ {panelData[`cantidad_retorno_${level}`].toLocaleString()}</td>
                    <td>{panelData[`porcentaje_retorno_${level}`]}%</td>
                    <td>
                      <div className="table-actions">
                        <button 
                          className="action-button edit"
                          onClick={() => {
                            setEditMode({ type: 'both', level });
                            setEditData({
                              cantidad: panelData[`cantidad_retorno_${level}`],
                              porcentaje: panelData[`porcentaje_retorno_${level}`]
                            });
                          }}
                        >
                          Editar
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Tabla de Referentes */}
            {referenteData && (
              <div className="referentes-section">
                <h3>Mis Referentes</h3>
                <table className="panel-table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Sucursal</th>
                      <th>Nivel</th>
                      <th>Comisión (%)</th>
                      <th>ID Padre</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(referenteData) ? (
                      referenteData.map((referente) => (
                        <tr key={referente.id}>
                          <td>{referente.id}</td>
                          <td>
                            {editingReferente?.id === referente.id ? (
                              <input
                                type="text"
                                value={editingReferente.nombre}
                                onChange={(e) => setEditingReferente({
                                  ...editingReferente,
                                  nombre: e.target.value
                                })}
                                className="edit-input"
                              />
                            ) : referente.nombre}
                          </td>
                          <td>
                            {editingReferente?.id === referente.id ? (
                              <input
                                type="number"
                                value={editingReferente.nivel}
                                onChange={(e) => setEditingReferente({
                                  ...editingReferente,
                                  nivel: parseInt(e.target.value)
                                })}
                                className="edit-input"
                              />
                            ) : referente.nivel}
                          </td>
                          <td>
                            {editingReferente?.id === referente.id ? (
                              <input
                                type="number"
                                step="0.01"
                                value={editingReferente.porcentaje_comision}
                                onChange={(e) => setEditingReferente({
                                  ...editingReferente,
                                  porcentaje_comision: e.target.value
                                })}
                                className="edit-input"
                              />
                            ) : `${parseFloat(referente.porcentaje_comision).toFixed(2)}%`}
                          </td>
                          <td>
                            {editingReferente?.id === referente.id ? (
                              <input
                                type="number"
                                value={editingReferente.id_padre || ''}
                                onChange={(e) => setEditingReferente({
                                  ...editingReferente,
                                  id_padre: e.target.value ? parseInt(e.target.value) : null
                                })}
                                className="edit-input"
                              />
                            ) : (referente.id_padre || '-')}
                          </td>
                          <td>
                            <div className="table-actions">
                              {editingReferente?.id === referente.id ? (
                                <>
                                  <button
                                    className="save-button"
                                    onClick={() => handleEditReferente(editingReferente)}
                                  >
                                    Guardar
                                  </button>
                                  <button
                                    className="cancel-button"
                                    onClick={() => setEditingReferente(null)}
                                  >
                                    Cancelar
                                  </button>
                                </>
                              ) : (
                                <button
                                  className="action-button edit"
                                  onClick={() => setEditingReferente({...referente})}
                                >
                                  Editar
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td>{referenteData.id}</td>
                        <td>
                          {editingReferente ? (
                            <input
                              type="text"
                              value={editingReferente.nombre}
                              onChange={(e) => setEditingReferente({
                                ...editingReferente,
                                nombre: e.target.value
                              })}
                              className="edit-input"
                            />
                          ) : referenteData.nombre}
                        </td>
                        <td>
                          {editingReferente ? (
                            <input
                              type="number"
                              value={editingReferente.nivel}
                              onChange={(e) => setEditingReferente({
                                ...editingReferente,
                                nivel: parseInt(e.target.value)
                              })}
                              className="edit-input"
                            />
                          ) : referenteData.nivel}
                        </td>
                        <td>
                          {editingReferente ? (
                            <input
                              type="number"
                              step="0.01"
                              value={editingReferente.porcentaje_comision}
                              onChange={(e) => setEditingReferente({
                                ...editingReferente,
                                porcentaje_comision: e.target.value
                              })}
                              className="edit-input"
                            />
                          ) : `${parseFloat(referenteData.porcentaje_comision).toFixed(2)}%`}
                        </td>
                        <td>
                          {editingReferente ? (
                            <input
                              type="number"
                              value={editingReferente.id_padre || ''}
                              onChange={(e) => setEditingReferente({
                                ...editingReferente,
                                id_padre: e.target.value ? parseInt(e.target.value) : null
                              })}
                              className="edit-input"
                            />
                          ) : (referenteData.id_padre || '-')}
                        </td>
                        <td>
                          <div className="table-actions">
                            {editingReferente?.id === referenteData.id ? (
                              <>
                                <button
                                  className="save-button"
                                  onClick={() => handleEditReferente(editingReferente)}
                                >
                                  Guardar
                                </button>
                                <button
                                  className="cancel-button"
                                  onClick={() => setEditingReferente(null)}
                                >
                                  Cancelar
                                </button>
                              </>
                            ) : (
                              <button
                                className="action-button edit"
                                onClick={() => setEditingReferente({...referenteData})}
                              >
                                Editar
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* Modal para editar valores */}
        {editMode.type && (
          <div className="modal-overlay" onClick={() => setEditMode({ type: null, level: null })}>
            <div className="modal-content-edit" onClick={e => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Editar Nivel {editMode.level}</h3>
                <button className="close-button" onClick={() => setEditMode({ type: null, level: null })}>×</button>
              </div>
              
              <div className="edit-form">
                <div className="form-groupRF">
                  <label>Cantidad de Envíos</label>
                  <input
                    type="number"
                    value={editData.cantidad}
                    onChange={(e) => setEditData({...editData, cantidad: e.target.value})}
                  />
                </div>
                <div className="form-groupRF">
                  <label>Porcentaje de Retorno</label>
                  <input
                    type="number"
                    step="0.1"
                    value={editData.porcentaje}
                    onChange={(e) => setEditData({...editData, porcentaje: e.target.value})}
                  />
                </div>
                <div className="modal-actions">
                  <button 
                    className="save-button"
                    onClick={() => handleEdit(
                      editMode.level,
                      'both',
                      { cantidad: editData.cantidad, porcentaje: editData.porcentaje }
                    )}
                  >
                    Guardar Cambios
                  </button>
                  <button 
                    className="cancel-button"
                    onClick={() => setEditMode({ type: null, level: null })}
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal para editar comisiones base */}
        {editingBaseCommissions && (
          <div className="modal-overlay" onClick={() => setEditingBaseCommissions(false)}>
            <div className="modal-content-edit" onClick={e => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Editar Comisiones Base</h3>
                <button className="close-button" onClick={() => setEditingBaseCommissions(false)}>×</button>
              </div>
              
              <div className="edit-form">
                <div className="form-row">
                  <div className="form-groupRF">
                    <label>Comisión Referido ($)</label>
                    <input
                      type="number"
                      value={baseCommissionValues.comision_referido}
                      onChange={(e) => setBaseCommissionValues({
                        ...baseCommissionValues,
                        comision_referido: e.target.value
                      })}
                      min="0"
                      step="0.01"
                    />
                  </div>
                  <div className="form-groupRF">
                    <label>Comisión Vendedor ($)</label>
                    <input
                      type="number"
                      value={baseCommissionValues.comision_vendedor}
                      onChange={(e) => setBaseCommissionValues({
                        ...baseCommissionValues,
                        comision_vendedor: e.target.value
                      })}
                      min="0"
                      step="0.01"
                    />
                  </div>
                </div>
                <div className="modal-actions">
                  <button 
                    className="save-button"
                    onClick={handleBaseCommissionsEdit}
                  >
                    Guardar Cambios
                  </button>
                  <button 
                    className="cancel-button"
                    onClick={() => {
                      setEditingBaseCommissions(false);
                      setBaseCommissionValues(null);
                    }}
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {isModalOpen && (
          <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
            <div className="modal-content-rf" onClick={e => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Nuevo Referente</h3>
                <button className="close-button" onClick={() => setIsModalOpen(false)}>×</button>
              </div>
              
              <form onSubmit={handleSubmit}>
                <div className="form-groupRF">
                  <label>Código de Sucursal</label>
                  <input
                    type="number"
                    name="codigo_sucursal"
                    value={formData.codigo_sucursal}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-groupRF">
                  <label>Porcentaje de Comisión</label>
                  <input
                    type="number"
                    step="0.1"
                    name="porcentaje_comision"
                    value={formData.porcentaje_comision}
                    onChange={handleChange}
                    required
                  />
                </div>

                <button type="submit" className="submit-buttonRF">
                  Crear Referente
                </button>
              </form>

              {message && (
                <div className={`message-container ${message.includes('Error') ? 'error' : 'success'}`}>
                  <p>{message}</p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Referente;
